import React from 'react';
import PropTypes from 'prop-types';
import { differenceWith, intersectionWith, isEqual } from 'lodash';
import map from 'lodash/map';
import { Filter } from './filter_components';
import { generateFiltersModel } from '../../common/models';
import FilterClearButton from './styled_components/FilterClearButton';

class SeasonsFilter extends React.Component {
  constructor(props) {
    super(props);
    this.updateSelection = this.updateSelection.bind(this);
    this.renderSeasonFilter = this.renderSeasonFilter.bind(this);
  }

  updateSelection(selectedSeasons) {
    let alreadySelectedSeason = this.props.selectedSeasons;
    const selected = intersectionWith(alreadySelectedSeason, selectedSeasons, isEqual);
    if (selected.length !== 0) {
      alreadySelectedSeason = differenceWith(alreadySelectedSeason, selectedSeasons, isEqual);
    } else {
      alreadySelectedSeason = alreadySelectedSeason.concat(selectedSeasons);
    }

    this.props.handleFilterClick(alreadySelectedSeason.map(el => el.toString()));
  }

  renderSeasonFilter(season, index) {
    const { isDesktop } = this.props;
    const available = intersectionWith(this.props.availableSeasons, season.data, isEqual).length !== 0;
    const selected = intersectionWith(this.props.selectedSeasons, season.data, isEqual).length !== 0;

    return (
      <Filter
        key={index}
        handleFilterClick={() => {
          this.updateSelection(season.data);
        }}
        isDesktop={isDesktop}
        firstElem={index === 0}
        id={season.text}
        checked={selected}
        active={available}
        value={season.text}
        title={season.text}
        type="season"
        filterName="seasonFilterSelect"
      />
    );
  }

  render() {
    const { currentSeason, availableSeasons, selectedSeasons, isDesktop, handleFilterClick } = this.props;

    const model = generateFiltersModel(currentSeason, availableSeasons, selectedSeasons);
    const atLeastOneSelected = selectedSeasons.length > 0;
    return (
      <div data-cy="filters-seasons">
        {atLeastOneSelected && <FilterClearButton isDesktop={isDesktop} handleClick={() => handleFilterClick([])} />}
        {map(model, (curr, index) => this.renderSeasonFilter(curr, index))}
      </div>
    );
  }
}

SeasonsFilter.propTypes = {
  availableSeasons: PropTypes.arrayOf(PropTypes.object),
  currentSeason: PropTypes.object,
  handleFilterClick: PropTypes.func,
  isDesktop: PropTypes.bool,
  selectedSeasons: PropTypes.arrayOf(PropTypes.object)
};

export default SeasonsFilter;
